<template>
  <node-view-wrapper>
    <div :class="$style.wrapper">
      <button type="button" :class="$style.button" @click="removeImage">
        <x-icon :class="$style.icon" />
      </button>

      <img
        :src="src || imagePlaceholder"
        :data-klaus-unsaved-image="node.attrs['data-klaus-unsaved-image']"
        :class="selected && $style.inFocus"
        loading="lazy"
        @error="handleError"
      />
    </div>
  </node-view-wrapper>
</template>

<script setup lang="ts">
import { NodeViewWrapper } from '@tiptap/vue-3'
import { XIcon } from '@klausapp/ui-kit/icons'
import type { NodeViewProps } from '@tiptap/core'
import { bus } from '@/utils/bus'
import { useRedirectedImageSource } from '@/composables/useRedirectedImageSource'
import imagePlaceholder from '@/modules/shared/TicketContent/utils/imagePlaceholder'

const props = defineProps<NodeViewProps>()

const handleError = () => {
  props.updateAttributes({ error: true })
}

const removeImage = () => {
  const pos = props.getPos()
  props.editor
    .chain()
    .deleteRange({ from: pos, to: pos + 1 })
    .focus()
    .run()
  bus.$emit('comment-editor-image-removed')
}

const { src } = useRedirectedImageSource(() => props.node.attrs.src)
</script>

<style module lang="scss">
.button {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -8px;
  right: -8px;
  height: 16px;
  width: 16px;
  background-color: black;
  color: white;
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-out;
  cursor: pointer;

  &:hover {
    background-color: var(--gray-70);
  }
}

.icon {
  height: 12px;
  width: 12px;
}

.wrapper {
  position: relative;
  display: inline-block;
  margin: 8px 0;

  &:hover .button {
    opacity: 1;
    pointer-events: unset;
  }
}

:global(.ProseMirror-focused) .inFocus {
  outline: 2px solid theme('colors.active.primary');
}
</style>
